import React from 'react';

function StatCard({ icon, value, label, change, color }) {
  return (
    <div className={`stat-card ${color}`}>
      <div className="stat-change">{change}</div>
      <div className="stat-icon">{icon}</div>
      <div className="stat-value">{value}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
}

export default StatCard;